/**
 * @generated SignedSource<<0a8a5c8198cd8800bda23280fcd21dcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsDrawer_Product$data = {
  readonly description: string;
  readonly " $fragmentType": "ProductDetailsDrawer_Product";
};
export type ProductDetailsDrawer_Product$key = {
  readonly " $data"?: ProductDetailsDrawer_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsDrawer_Product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsDrawer_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "79d5ba725cfa007cf0a1877ccde086eb";

export default node;
